export const tmaisRafflesColumns = [
  { label: 'Status', value: 'status', className: 'w-[120px]' },
  { label: 'Autor', value: 'author' },
  { label: 'Nome', value: 'display_name' },
  { label: 'Valido até', value: 'available_until' },
  { label: 'Dia do sorteio', value: 'select_winner_at' },
  { label: 'Ações', value: 'actions', className: "w-11" },
]
